import React, { useEffect, useState } from 'react';

import MainMenu from './compose/MainMenu';
import Operations from './compose/Operations';
import UnwindingProposalCenterPage from '../../V2/pages/UnwindingProposalCenterPage';

export const menu = [
  {
    descricaoMenu: 'Operações',
    referenciaMenu: '/central-de-propostas/operacoes',
    referenciaParametro: 'operations',
  },
  {
    descricaoMenu: 'Antecipações e Novas contratações',
    referenciaMenu: '/central-de-propostas/antecipacoes',
    referenciaParametro: 'unwindings',
  },
];

const ProposalsCenterPage = ({ location }) => {
  const { pathname } = location;
  const [menuSelected, setMenuSelected] = useState([]);

  useEffect(() => {
    let currentPath = pathname;
    if (pathname === '/central-de-propostas') {
      currentPath = '/central-de-propostas/operacoes';
    }

    const currentMenu = menu.filter(m => m.referenciaMenu === currentPath);
    setMenuSelected(currentMenu);
  }, [pathname]);

  return (
    <div data-testid="proposal-center-page">
      <MainMenu
        menu={menu}
        menuSelected={menuSelected[0]?.referenciaMenu}
      />

      {menuSelected[0]?.referenciaParametro === 'operations' && <Operations />}
      {menuSelected[0]?.referenciaParametro === 'unwindings' && <UnwindingProposalCenterPage />}
    </div>
  );
};

export default ProposalsCenterPage;
